import React from "react";
import { connect } from 'react-redux';
import ReactDOM from "react-dom";

import { ObtenerNeumaticosMarcasEnAPI, ActualizarReglasNeumaticosMarcasEnAPI } from "../../action/actionCreatorsRequests";
import {
    traducirPagina, MSGOK, obtenerUsuario, obtenerToken

} from "../../librerias/funciones"
import { Checkbox, Select } from 'antd';
import {
    CloseOutlined

} from '@ant-design/icons';
import { Layout } from 'antd';
const { Content } = Layout;
const { Option } = Select;

const ReglasFiltroNeumatico = ({ }) => {
    const [alturaSubmenu, setAlturaSubmenu] = React.useState(0);
    const ref = React.useRef(null)

    const [reglasAlmacenes, setReglasAlmacenes] = React.useState([]);
    const [hayLicencias, seHayLicencias] = React.useState(false);
    const [sociosLocal, setSociosLocal] = React.useState([]);
    const [socioSeleccionado, setSocioSeleccionado] = React.useState(0);
    const [grupoSeleccionado, setGrupoSeleccionado] = React.useState([]);


    const modelarDatos = (marcas) => {
        let listaMarca = [];
        let objetoNuevoMarcas = [];
        let contAux = 0;

        for (var i = 0; i < marcas.length; i++) {
            contAux += 1;
            if (contAux <= 4) {
                listaMarca.push({ "ID": marcas[i].ID, "NOMBRE": marcas[i].NOMBRE, "SELECCIONADO": marcas[i].SELECCIONADO })
                if ((marcas.length - 1) === i) {
                    objetoNuevoMarcas.push({ "lista": listaMarca });
                }
            } else {
                objetoNuevoMarcas.push({ "lista": listaMarca });
                contAux = 0;
                listaMarca = []
                i = (i - 1)
            }
        }
        return objetoNuevoMarcas.length === 0 ? null : objetoNuevoMarcas;
    }




    const obtenerReglasAlmacenes = (ORDERCOLUM, ORDERDIR, ID, DESCRIPCION, ID_SOCIO) => {
        setReglasAlmacenes([])
        ObtenerNeumaticosMarcasEnAPI(10000, 1, ORDERCOLUM, ORDERDIR, ID, DESCRIPCION, ID_SOCIO).then((reglas) => {
            if (reglas !== undefined) {
                if (reglas.REGISTROS !== null && reglas.REGISTROS.length > 0) {
                    setReglasAlmacenes(modelarDatos(reglas.REGISTROS))
                    let seleccionados = reglas.REGISTROS.filter((regla) => regla.SELECCIONADO === true)
                    setGrupoSeleccionado([...seleccionados])

                } else {
                    setReglasAlmacenes(null)
                }
            }
        })
    }



    const grupoSeleccionadoActual = (registro) => {
        if (grupoSeleccionado.length === 0) {
            setGrupoSeleccionado([registro])
        } else {
            let existeGrupo = grupoSeleccionado.filter((ITEM) => ITEM.ID === registro.ID)
            if (existeGrupo.length === 0) {
                //añadir
                let recuperarDatos = [...grupoSeleccionado, registro];
                setGrupoSeleccionado([recuperarDatos])

            } else {
                //eliminnar
                let nuevaLista = grupoSeleccionado.filter((eliminnar) => eliminnar.ID !== registro.ID)
                setGrupoSeleccionado([nuevaLista])
            }
        }
    }



    const gestionarRegla = (esAlta, ID) => {
        ActualizarReglasNeumaticosMarcasEnAPI(esAlta ? 0 : 2, socioSeleccionado, ID).then(estado => {
            if (estado.OK) {
                MSGOK(traducirPagina("Info_regla_actualizada"), "botton-right")

                obtenerReglasAlmacenes(1, "A", "", "", socioSeleccionado)

            } else {
                //setObtenerMarcasVehiculo(null);
            }
        })
    }



    React.useEffect(() => {
        if (ref.current !== null) {
            setAlturaSubmenu(ref.current.clientHeight)
        }
    })



    React.useEffect(() => {
        if (obtenerToken() !== undefined) {
            let accesoLicencia = obtenerUsuario();
            setSociosLocal(accesoLicencia.SOCIOS)
            obtenerReglasAlmacenes(1, "A", "", "", accesoLicencia.SOCIOS[0].ID_SOCIO)
            setSocioSeleccionado(accesoLicencia.SOCIOS[0].ID_SOCIO)
        }
    }, [])



    document.getElementById("tituloMenu") !== null && ReactDOM.render(
        <>
            {`SERTEC - ${traducirPagina("Reglas_filtrado_neumatico").toUpperCase()}`}
        </>,
        document.getElementById("tituloMenu")
    );




    return (
        <>
            <div className="menu_mantenimiento" ref={ref}>
                <div className="mantenimiento_item1" style={{ gap: '10px' }}>
                    {sociosLocal !== null ?
                        <Select
                            showSearch
                            allowClear={obtenerUsuario().SOCIOS.length > 1 ? true : false}
                            defaultValue={obtenerUsuario().SOCIOS[0].ID_SOCIO}
                            size={"large"}
                            placeholder={traducirPagina("Seleccione_socio")}
                            style={{ width: "250Px", textAlign: 'left' }}
                            optionFilterProp="children"
                            onChange={(e) => {

                                let SOCIO = e === undefined || e === null ? 0 : e
                                setSocioSeleccionado(parseInt(SOCIO));
                                obtenerReglasAlmacenes(1, "A", "", "", SOCIO)
                            }}
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {sociosLocal.length > 0 ?
                                sociosLocal.map((socio) =>
                                    <Option key={socio.ID_SOCIO} value={socio.ID_SOCIO}>{socio.NOMBRE_SOCIO}</Option>
                                )
                                :
                                null
                            }
                        </Select>
                        :
                        <div style={{ textAlign: 'center' }}>
                            <h4>{traducirPagina("Info_error_socio")}</h4>
                        </div>
                    }



                </div>

                <div className="mantenimiento_item2" style={{ gap: '10px' }}>
                    <div className="containerFiltroNeumatico">
                        {
                            grupoSeleccionado.filter((grupo) => grupo.SELECCIONADO === true).map((item) =>
                                <div title="Eliminar marca" onClick={() => {
                                    grupoSeleccionadoActual(item);
                                    gestionarRegla(false, item.ID)
                                }}><span style={{ margin: '0px 2px 0px 2px' }}>{item.NOMBRE} </span>  <CloseOutlined style={{ fontSize: '10px', verticalAlign: 'middle', margin: '0px 2px 0px 2px' }} /> </div>

                            )
                        }
                    </div>

                </div>
            </div>



            <div className="margen_tabla">
                {reglasAlmacenes === null ?
                    <div style={{ textAlign: 'center' }}>
                        <h4>{traducirPagina("Sin_registros")}</h4>
                    </div>
                    :
                    reglasAlmacenes.length > 0 ?
                        <div className="container_tabla_generico" style={{ height: `calc(100vh - ${(120 + alturaSubmenu)}px )` }}>
                            {reglasAlmacenes === null ?
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '70vh' }}> <h3>{traducirPagina("Sin_registros")}</h3> </div>
                                :
                                reglasAlmacenes.length > 0 ?
                                    reglasAlmacenes.map((item, i) =>
                                        <div key={i} style={{ padding: '5px', fontSize: '14px', fontWeight: '500', display: 'flex', justifyContent: 'flex-start' }}>
                                            {item.lista.map((row, i) =>
                                                <div style={{ width: '50%' }} key={i}>
                                                    <Checkbox key={i} defaultChecked={row.SELECCIONADO} onChange={(e) => {
                                                        grupoSeleccionadoActual(row);
                                                        gestionarRegla(e.target.checked, row.ID)
                                                    }}> {row.NOMBRE} </Checkbox>
                                                </div>
                                            )}
                                        </div>
                                    )
                                    :
                                    null
                            }
                        </div>
                        :
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                }
            </div>
        </>
    );
}

const mapStateToProps = state => {
    return {

    };
}

export default connect(mapStateToProps)(ReglasFiltroNeumatico);






